import { render, staticRenderFns } from "./QRCodeOptionsTabs.vue?vue&type=template&id=4f306ff6"
import script from "./QRCodeOptionsTabs.vue?vue&type=script&lang=js"
export * from "./QRCodeOptionsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports